import { Component, OnInit, Input } from '@angular/core';
import { Pays } from 'app/models';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from 'app/utils/notifications.service';
import { PaysService } from 'app/core/pays.service';

@Component({
  selector: 'app-ajoutpays',
  templateUrl: './ajoutpays.component.html',
  styleUrls: ['./ajoutpays.component.css']
})
export class AjoutpaysComponent implements OnInit {
  @Input()
  pays:Pays;
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private activeModal: NgbActiveModal,
    private notification: NotificationsService,
    private paysService:PaysService
  ) { }

  ngOnInit() {
    this.initForm();
  }

  submitForm() {
    const valeur: any = this.form.value;
    console.log(valeur);
    this.paysService.create(valeur).subscribe(
      pays => {
        if (this.pays) {
          this.notification.addToast(
            " Matrimoniale a ete bien créee",
            "infos",
            "success"
          );
        } else {
          this.notification.addToast(
            " Matrimoniale a ete bien créee",
            "infos",
            "success"
          );
        }
      },
      error => {
        if (this.pays) {
          this.notification.addToast(
            "Erreur sur Modification",
            'Attention', 'error'
          );
        } else {
          this.notification.addToast(
            "Erreur sur Création",
            'Attention', 'error'
          );
        }
      }
    );

    this.activeModal.dismiss("cancelled by user");
    this.ngOnInit();
  }


  public initForm() {
    if (this.pays) {
      this.form = this.formBuilder.group({
        code: [this.pays.code, Validators.required],
        libelle: [this.pays.libelle, Validators.required],
        nationnalite: [this.pays.nationnalite, Validators.required],
        id: [this.pays.id]
      });
    } else {
      this.form = this.formBuilder.group({
        code: [null, Validators.required],
        libelle: [null, Validators.required],
        nationnalite: [null, Validators.required],
        id: [null]
      });
    }
  }
  dismiss() {
    this.activeModal.dismiss("cancelled by user");
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/parametrage/matrimoniale/pays/ajoutpays/ajoutpays.component.ts